import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Trans } from 'react-i18next'

import AccountSegmentSelector from './AccountSegmentSelector'
import PrivacyTermsFooter from './PrivacyTermsFooter'

import classes from './SignUpSegmentSelector.module.scss'

const defaultHeading = (
  <Trans i18nKey='auth.signUpSegmentSelector.heading'>
    Let&apos;s get to know you...
    <br />
    Which describes you best?
  </Trans>
)

const SignUpSegmentSelector = ({ onIndividualClick, onFamilyClick, heading = defaultHeading, showCoachOption = true }) => (
  <>
    <h5 className={classNames(classes.titleText, 'mt-4')}>{heading}</h5>

    <AccountSegmentSelector
      onIndividualClick={onIndividualClick}
      onFamilyClick={onFamilyClick}
      showCoachOption={showCoachOption}
      wrapperClassName='mb-3 w-100'
    />

    <PrivacyTermsFooter />
  </>
)

SignUpSegmentSelector.propTypes = {
  onIndividualClick: PropTypes.func.isRequired,
  onFamilyClick: PropTypes.func.isRequired,
  heading: PropTypes.node,
  showCoachOption: PropTypes.bool,
}

export default SignUpSegmentSelector
